import {Language} from '../umpire-language-service';

export interface UmpirePublicationCategory {
  id: string;

  type: string;

  name: string | null;

  available_translations: Language[];

  locale: Language;
}
